const jingrqEndpointConfig = {
  httpEndpoint: 'https://upeklfr4gj.execute-api.us-west-2.amazonaws.com/test/',
  cognitoIdentityPoolId: 'us-west-2:ccddcb31-063d-43e9-a241-c046762695fa',
  region: 'us-west-2',
};

const liweihanEndpointConfig = {
  httpEndpoint: 'https://3wp4twga1d.execute-api.us-west-2.amazonaws.com/test/',
  cognitoIdentityPoolId: 'us-west-2:cc997fa5-4522-4eb2-b83a-60214130518c',
  region: 'us-west-2',
};

const alphaEndpointConfig = {
  httpEndpoint: 'https://e337xxfq8i.execute-api.us-west-2.amazonaws.com/alpha/',
  cognitoIdentityPoolId: 'us-west-2:7e4f50ee-5b3f-4f35-a31e-911f2b7218b7',
  region: 'us-west-2',
};

const prodEndpointConfig = {
  httpEndpoint: 'https://k5d5icrcl1.execute-api.us-west-2.amazonaws.com/prod/',
  cognitoIdentityPoolId: 'us-west-2:26599e39-ed17-4355-977f-46ddbcba2492',
  region: 'us-west-2',
};

export function getAsinMetricsEndpointConfig() {
  const url = window.location.hostname;
  switch (url) {
    case 'localhost.a2z.com':
      // Change to your SAM API Gateway endpoint here for testing locally
      // TODO: find a way so that developer don't have to change this each time to run locally.
      return jingrqEndpointConfig;
    case 'tools-jingrq.profit-intelligence.selling-partners.a2z.com':
      return jingrqEndpointConfig;
    case 'tools-liweihan.profit-intelligence.selling-partners.a2z.com':
      return liweihanEndpointConfig;
    case 'tools-alpha.profit-intelligence.selling-partners.a2z.com':
      return alphaEndpointConfig;
    case 'tools.profit-intelligence.selling-partners.a2z.com':
      return prodEndpointConfig
    default:
      throw new Error(`No endpoint configured for ${url}`);
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/asin_metrics/asin-metrics-endpoint-configs.js